import { FLOTABOT } from "../components/layout/secciones";
import { abrirSesionEnFlotaBot } from "./ssoFlotaBot";

/* Subir un Excel de internos y bajarlo con la ubicación actual de cada uno.
 * Pedido de Leonel Astroza (Satelital, 23/09).
 *
 * ── POR QUÉ EL TRABAJO LO HACE FLOTABOT ───────────────────────────────────
 *
 * El hub es React estático: no tiene servidor. La posición de cada unidad vive
 * en FlotaBot, que ya la junta de todas las fuentes (My SCANIA + LYNX +
 * Michelin + Sascar + rFMS) para el mapa y para /api/v1/posicion. Rehacer eso
 * en el navegador sería una segunda copia de la parte más delicada. Así que el
 * archivo viaja a FlotaBot por el mismo puente SSO que la planilla de
 * movimientos.
 *
 * ── LA RESPUESTA BUENA NO ES JSON ─────────────────────────────────────────
 *
 * A diferencia de `llamar()` de planillaMovimientos, cuando sale bien FlotaBot
 * devuelve el EXCEL anotado (un blob), no un JSON. El error sí es JSON, con
 * `motivo`. Por eso esto no reusa `llamar()`: distinguir blob de JSON en aquél
 * lo volvería ambiguo para las dos pantallas.
 */

const NO_PUEDO = "No podés pasar.";

export function ubicacionesDeExcel(archivo) {
  return subirExcel("/api/satelital/posiciones", archivo, "ubicaciones.xlsx");
}

/* Ticket #421 (Leonel, 15/10): el mismo viaje, pero lo que vuelve es SU
 * Excel con las celdas vacías completadas con los datos de la empresa
 * (patentes, tractor, chofer, DNI, teléfono, marca). FlotaBot cuenta cuántas
 * completó y cuántas quedaron sin dato en dos headers. */
export async function completarExcel(archivo) {
  const r = await subirExcel("/api/satelital/completar", archivo, "completo.xlsx");
  if (!r.ok) return r;
  const n = (h) => {
    const v = parseInt(r.headers?.get(h) ?? "", 10);
    return Number.isFinite(v) ? v : null;
  };
  return { ...r, completadas: n("X-Completadas"), sinDato: n("X-Sin-Dato") };
}

async function subirExcel(ruta, archivo, nombrePorDefecto) {
  const sesion = await abrirSesionEnFlotaBot();
  if (!sesion.ok) {
    return {
      ok: false,
      mensaje:
        sesion.motivo === "sin-sesion"
          ? "Se cerró la sesión. Entrá de nuevo y probá otra vez."
          : "No se pudo hablar con FlotaBot. Puede estar reiniciando; probá en un minuto.",
    };
  }

  const fd = new FormData();
  fd.append("archivo", archivo);

  let r;
  try {
    r = await fetch(`${FLOTABOT}${ruta}`, {
      method: "POST",
      credentials: "include",
      body: fd,
    });
  } catch {
    return { ok: false, mensaje: "No se pudo conectar con FlotaBot." };
  }

  if (r.status === 403) return { ok: false, mensaje: NO_PUEDO };
  if (r.status === 401) {
    return {
      ok: false,
      mensaje: "FlotaBot no reconoció la sesión. Recargá la página y probá otra vez.",
    };
  }
  if (!r.ok) {
    /* El error viene en JSON con `motivo`, escrito para leerse. */
    let motivo = `FlotaBot contestó ${r.status}.`;
    try {
      const d = await r.json();
      if (d && d.motivo) motivo = d.motivo;
    } catch {
      /* respuesta sin cuerpo: queda el genérico */
    }
    return { ok: false, mensaje: motivo };
  }

  const blob = await r.blob();
  const cd = r.headers.get("Content-Disposition") || "";
  const m = /filename="?([^"]+)"?/.exec(cd);
  return { ok: true, blob, nombre: m ? m[1] : nombrePorDefecto, headers: r.headers };
}

/* Dispara la descarga del Excel en el navegador. */
export function bajar(blob, nombre) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre || "ubicaciones.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
